import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PrivateLayoutHeaderProps } from 'common/Components/PrivateLayout/Header/types';
import { RootState } from '../../app/store';

import { LayoutState } from './types';

import HomeSVG from 'ui/assets/images/home/dashboard.svg';

const initialState: LayoutState = {
    header: {
        icon: HomeSVG,
        title: 'Page Title',
        user: {
            id: '1',
            firstName: '',
            lastName: '',
            avatar: '',
        },
        layout: 'default' as const,
        theme: 'default' as const,
    },
};

export const layoutSlice = createSlice({
    name: 'layout',
    initialState: initialState,
    reducers: {
        setHeader: (state, action: PayloadAction<PrivateLayoutHeaderProps>) => {
            state.header = action.payload;
        },
    },
});

export const { setHeader } = layoutSlice.actions;

export const selectHeader = (state: RootState) => state.layout.header;

export default layoutSlice.reducer;
